var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between"},[_c('h6',[_vm._v(_vm._s(_vm.item.workload)+" Horas")]),_c('h5',{staticClass:"text-success"},[_c('b',[_vm._v(_vm._s(_vm._f("formatMoney")(_vm.item.value)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }